import { FC } from 'react';
import cn from 'bem-cn';

import tickMobile from '../../../images/tick_mobile.png';
import tickDesktop from '../../../images/tick_desktop.png';
import bowlMobile from '../../../images/bowl_mobile.png';
import bowlDesktop from '../../../images/bowl_desktop.png';
import capMobile from '../../../images/cap_mobile.png';
import capDesktop from '../../../images/cap_desktop.png';

import { ScreenSize, useGetScreenSize } from '../../../hooks';

import { Icon, ImageWithFadeIn, Modal, Stack } from '../../UI';
import { HowToEarnPointsModalProps } from './HowToEarnPointsModal.types';

import './HowToEarnPointsModal.scss';

const b = cn('how-to-earn-points-modal');

export const HowToEarnPointsModal: FC<HowToEarnPointsModalProps> = ({ isOpen, onClose }) => {
    const screenSize = useGetScreenSize();
    const isTouch = screenSize < ScreenSize.Tablet;

    return (
        <Modal isOpen={isOpen} onClose={onClose} showDefaultCloseButton={false}>
            <Stack className={b()}>
                <h2 className={b('title')}>Как повысить рейтинг</h2>

                <div className={b('content')}>
                    <div className={b('card')}>
                        <h3>Промптите</h3>
                        <p>Применяйте промпты в Алисе AI и публикуйте свои для других пользователей</p>
                        <ImageWithFadeIn src={isTouch ? tickMobile : tickDesktop} alt="" />
                    </div>

                    <div className={b('card')}>
                        <h3>Участвуйте в активностях</h3>
                        <p>Побеждайте в челленджах и выполняйте ежедневные задания</p>
                        <ImageWithFadeIn src={isTouch ? bowlMobile : bowlDesktop} alt="" />
                    </div>

                    <div className={b('card')}>
                        <h3>Обучайтесь</h3>
                        <p>Смотрите лекции и успешно завершайте начатые курсы</p>
                        <ImageWithFadeIn src={isTouch ? capMobile : capDesktop} alt="" />
                    </div>
                </div>
                <button className={b('close-button')} onClick={onClose} type="button" aria-label="Закрыть">
                    <Icon name="close" size={24} />
                </button>
            </Stack>
        </Modal>
    );
};
